import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function materias(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@materias/REQUEST_SUCCESS': {
        draft.data = action.payload.materias;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
